// https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#ECMAScript_(JavaScript/ActionScript,_etc.)
// Also check this tile calculator by coordinates: https://oms.wff.ch/calc.htm
const getTileXYByCoordinatesAndZoomLevel = (
  lon: number,
  lat: number,
  zoom: number
): [x: number, y: number] => {
  const latRadians = lat * (Math.PI / 180);
  const n = Math.pow(2, zoom);

  const x = Math.min(Math.floor(n * ((lon + 180) / 360)), n - 1);
  const y = Math.floor(
    (n * (1 - Math.log(Math.tan(latRadians) + 1 / Math.cos(latRadians)) / Math.PI)) / 2
  );

  return [x, y];
};

export default getTileXYByCoordinatesAndZoomLevel;
